<template>
    <div class="invoice">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="header">
                <div class="pull-right" v-if="reservation.paid">
                    <span class="paid">Paid</span>
                </div>

                <h1>{{meta.name}}</h1>

                <p class="text-muted">
                    {{meta.address}}
                </p>
            </div>

            <table class="table visible-print">
                <tbody>
                    <tr>
                        <td>Billing</td>
                        <td colspan="2">{{meta.billing}}</td>
                    </tr>

                    <tr>
                        <td>Stay</td>
                        <td>
                            <span>{{reservation.name}}</span><br />
                            <span class="roomName">{{reservation.room.title}}</span><br />
                        </td>
                        <td>
                            <small class="grey">Arrival</small><br />
                            <small class="text-uppercase">{{reservation.arrival.date | moment("ddd, MMM Do YYYY")}}<br />14:00</small><br />
                            <small class="grey">Departure</small><br />
                            <small class="text-uppercase">{{departure}}<br />11:00</small>
                        </td>
                    </tr>

                    <tr>
                        <td>Invoice ID</td>
                        <td colspan="2">
                            {{reservation.readableId}}
                        </td>
                    </tr>

                    <tr>
                        <td>Date issued</td>
                        <td colspan="2">
                            {{reservation.arrival.date | moment("MMM DD, YYYY")}}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="info hidden-print">
                <div class="row">
                    <div class="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <span class="text-muted">
                                    Billing
                                </span>
                            </div>

                            <div class="col-lg-9 col-md-8 col-sm-8">
                                <span class="billing">{{meta.billing}}</span><br />
                            </div>
                        </div>

                        <br />

                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <span class="text-muted">
                                    Stay
                                </span>
                            </div>

                            <div class="col-lg-9 col-md-8 col-sm-8">
                                <span>{{reservation.name}}</span><br />

                                <span class="roomName">{{reservation.room.title}}</span><br />

                                <div class="arrival-departure">
                                    <div>
                                        <small class="grey">arrival</small>
                                        <small class="text-uppercase">{{reservation.arrival.date | moment("ddd, MMM Do YYYY")}}<br />14:00</small>
                                    </div>

                                    <div>
                                        <small class="grey">departure</small>
                                        <small class="text-uppercase">{{departure}}<br />11:00</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                    </div>

                    <div class="col-lg-4 col-md-5 hidden-sm hidden-xs text-right right">
                        <div>
                            <span class="text-muted">
                                Invoice ID
                            </span>

                            <br />

                            <span>{{reservation.readableId}}</span>
                        </div>

                        <div>
                            <span class="text-muted">
                                Date issued
                            </span>

                            <br />

                            <span class="text-uppercase">{{reservation.arrival.date | moment("MMM DD, YYYY")}}</span>
                        </div>
                    </div>

                    <div class="visible-xs visible-sm">
                        <div>
                            <span class="text-muted">
                                Invoice ID
                            </span>

                            <br />

                            <span>{{reservation.id}}</span>
                        </div>

                        <div>
                            <span class="text-muted">
                                Date issued
                            </span>

                            <br />

                            <span class="text-uppercase">{{reservation.arrival.date | moment("MMM DD, YYYY")}}</span>
                        </div>
                    </div>
                </div>
            </div>

             <table class="table invoice-lines">
                 <thead>
                    <tr>
                        <th class="col-sm-5">Product</th>
                        <th class="col-sm-2">Quantity</th>
                        <th class="col-sm-2 text-right">Unit price</th>
                        <th class="col-sm-3 text-right">Total</th>
                    </tr>
                 </thead>

                 <tbody>
                    <tr>
                        <td>
                            {{reservation.room.title}}<br />
                            <small class="text-muted">Room</small>
                        </td>

                        <td>
                            {{days}}&nbsp;&nbsp;<small class="text-muted">night(s)</small>
                        </td>

                        <td class="text-right">
                            <small>DKK</small> {{reservation.price / days | fixedNumber(2) | moneyFormat}}
                        </td>

                        <td class="text-right">
                            <span class="text-muted">
                            <small>DKK</small> {{reservation.price | fixedNumber(2) | moneyFormat}}
                            </span>
                        </td>
                    </tr>

                    <tr v-for="product in reservation.products">
                        <td>
                            {{product.title}}<br />
                            <small class="text-muted">Product</small>
                        </td>

                        <td>
                            {{product.quantity}}
                        </td>

                        <td class="text-right">
                            <small>DKK</small> {{product.price | fixedNumber(2) | moneyFormat}}
                        </td>

                        <td class="text-right">
                            <span class="text-muted">
                                <small>DKK</small> {{product.price * product.quantity | fixedNumber(2) | moneyFormat}}
                            </span>
                        </td>
                    </tr>

                    <tr v-if="reservation.numberOfBreakfasts > 0">
                        <td>
                            Breakfast<br />
                            <small class="text-muted">Product</small>
                        </td>

                        <td>
                            {{reservation.numberOfBreakfasts}}&nbsp;&nbsp;<small class="text-muted">person(s)</small>
                        </td>

                        <td class="text-right">
                            <small>DKK</small> {{reservation.totalPriceBreakfast / reservation.numberOfBreakfasts | fixedNumber(2) | moneyFormat}}
                        </td>

                        <td class="text-right">
                            <small>DKK</small> {{reservation.totalPriceBreakfast | fixedNumber(2) | moneyFormat}}
                        </td>
                    </tr>
                 </tbody>
             </table>

            <br />

            <div class="total">
                <div class="row">
                    <div class="col-xs-6">
                        Subtotal (excl. tax)
                    </div>

                    <div class="col-xs-6 text-right">
                        <small>DKK</small> {{total * 0.8 | fixedNumber(2) | moneyFormat}}
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        Tax
                    </div>

                    <div class="col-xs-6 text-right">
                        <small>DKK</small> {{total * 0.20 | fixedNumber(2) | moneyFormat}}
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <strong>Total</strong>
                    </div>

                    <div class="col-xs-6 text-right">
                        <strong><small>DKK</small> {{total | fixedNumber(2) | moneyFormat}}</strong>
                    </div>
                </div>
            </div>

            <hr />

            <div class="appreciate-your-business">
                We appreciate the confidence you have placed in us and we look forward to providing you with the best possible service in the future.
            </div>
        </template>
    </div>
</template>

<style lang="scss">
    .invoice {
        width: 100%;

        padding: 50px 60px;
        border: 1px solid #ccc;
        box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
        background-color: #fff;

        .info {
            width: calc(100% + 120px);
            background-color: #f5f5f5;
            margin: 40px -60px;
            padding: 40px 60px;

            line-height: 25px;

            font-size: 15px;

            .text-muted {
                display: inline-block;
                font-size: 13px;
                font-weight: 500;
            }

            .billing {
                font-size: 14px;
                line-height: 12px;
                white-space: pre;
            }

            .right {
                > div {
                    margin-bottom: 15px;
                }
            }

            .roomName {
                display: inline-block;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
                margin-bottom: 10px;
            }

            .arrival-departure {
                > div {
                    float: left;
                    margin-right: 35px;
                    font-size: 14px;
                    line-height: 20px;

                    .grey {
                        display: block;
                        color: #7b7b7b;
                        min-width: 70px;
                    }
                }
            }
        }

        .header {
            margin-bottom: 40px;

            h1 {
                font-size: 25px;
                margin-top: 0;
            }
        }

        .invoice-lines {
            margin: 20px 0;

            td {
                vertical-align: middle;
            }
        }

        .total {
            margin-bottom: 30px;
            .row {
                margin-bottom: 15px;

                strong {
                    font-size: 15px;
                }
            }
        }

        .appreciate-your-business {
            max-width: 40%;
        }

        .paid {
            color: #ea0307;
            font-size: 25px;
            font-weight: 600;
            text-transform: uppercase;
            border: 2px solid #ea0307;
            border-radius: 7px;
            padding: 2px 6px;
        }

        .text-right {
            text-align: right;
        }

        @media print {
            .header {
                margin-bottom: 20px;
            }
        }
    }
</style>

<script>
    import Card from '@/components/layout/Card'
    import Loader from '@/components/layout/Loader'

    const MetaService = require('@/services/hotel/MetaService')
    const ReservationService = require('@/services/reservations/ReservationService')

    const moment = require('moment')

    export default {
        props: {
            id: String
        },

        data() {
            return {
                reservation: null,
                hasLoaded: false,
                meta: {}
            }
        },

        computed: {
            departure() {
                if (!this.reservation) {
                    return
                }

                const date = moment(this.reservation.departure.date)

                date.add(1, 'day')

                return date.format('ddd, MMM Do YYYY')
            },

            days() {
                if (!this.reservation) {
                    return 0
                }

                const arrival = moment(this.reservation.arrival.date)
                const departure = moment(this.reservation.departure.date)

                return departure.diff(arrival, 'days') + 1
            },

            total() {
                const reservation = this.reservation

                let total = 0

                total += reservation.price
                total += reservation.totalPriceBreakfast
                total += reservation.totalProductPrice

                return total
            }
        },

        mounted() {
            this.load()

            eventHub.$off('products.updated', this.load)
            eventHub.$off('reservation.updated', this.load)
        },

        destroyed() {
            eventHub.$on('products.updated', this.load)
            eventHub.$on('reservation.updated', this.load)
        },

        methods: {
            load() {
                this.hasLoaded = false
                this.reservation = null

                const options = {
                    includes: ['room']
                }

                ReservationService.find(this.id, options, (response) => {
                    const data = response.data

                    this.reservation = data
                    this.hasLoaded = true
                })

                MetaService.findAll({}, (response) => {
                    const data = response.data

                    data.rows.forEach((meta) => {
                        this.$set(this.meta, meta.field, meta.value)
                    })
                })
            },

            update() {
                this.hasLoaded = false

                ReservationService.update(this.$route.params.id, this.reservation, (response) => {
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Card,
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// Invoice.vue?709ce596